import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';

const CreateCustomerDialog = ({
  open,
  selectedLead,
  processing,
  onClose,
  onSubmit,
}) => {
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    password: '',
  });

  const generatePassword = () => {
    const length = 12;
    const charset =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    let password = '';
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  };

  React.useEffect(() => {
    if (selectedLead && open) {
      setFormData({
        name: selectedLead.name || '',
        email: selectedLead.email || '',
        password: generatePassword(),
      });
    }
  }, [selectedLead, open]);

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleRegeneratePassword = () => {
    setFormData((prev) => ({
      ...prev,
      password: generatePassword(),
    }));
  };

  const handleSubmit = () => {
    onSubmit({
      ...formData,
      flag: 'lead_customer',
      lead_id: selectedLead?.id,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Customer from Lead</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label="Customer Name"
            value={formData.name}
            onChange={handleChange('name')}
            fullWidth
            required
            variant="outlined"
            sx={{ '& .MuiInputBase-root': { borderRadius: '8px' } }}
          />

          <TextField
            label="Email"
            type="email"
            value={formData.email}
            onChange={handleChange('email')}
            fullWidth
            required
            variant="outlined"
            sx={{ '& .MuiInputBase-root': { borderRadius: '8px' } }}
          />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
              label="Password"
              value={formData.password}
              onChange={handleChange('password')}
              fullWidth
              required
              variant="outlined"
              sx={{ '& .MuiInputBase-root': { borderRadius: '8px' } }}
            />
            <Button
              onClick={handleRegeneratePassword}
              size="small"
              sx={{
                mt: 1,
                borderRadius: '20px',
                padding: '6px 12px',
                '&:hover': {
                  backgroundColor: '#1976d2',
                },
              }}
            >
              Regenerate Password
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This will add a customer account with the flag &quot;lead_customer&quot;.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={
            !formData.name || !formData.email || !formData.password || processing
          }
          startIcon={processing ? <CircularProgress size={20} /> : null}
          sx={{
            borderRadius: '8px',
            padding: '8px 16px',
            textTransform: 'none',
          }}
        >
          Add Customer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCustomerDialog;
